// extracted by mini-css-extract-plugin
export default {"icon":"index_icon__+LRL0","iconStyled":"index_iconStyled__SOxqd"};